const line = (ev) => {
  if (ev.type === "press") return `${ev.name} pressed`;
  if (ev.type === "toggle") return `${ev.name} ${ev.on ? "ON" : "OFF"}`;
  return `${ev.name} → ${ev.value}`;
};

export const ConsoleLog = ({ log }) => (
  <aside data-testid="console-log" className="border border-slate-800 bg-slate-950/70 p-5">
    <p className="lab-label">Live input</p>
    {log.length === 0 ? (
      <p data-testid="console-log-empty" className="mt-3 text-sm text-slate-500">Nothing yet. Press, flip or turn something on either box.</p>
    ) : (
      <ol className="mt-3 grid gap-1.5 font-mono text-xs">
        {log.map((ev, i) => (
          <li key={ev.at + ev.id + i} data-testid={`console-log-${i}`} className={i === 0 ? "text-cyan-200" : "text-slate-500"}>
            <span className="text-slate-600">{new Date(ev.at).toLocaleTimeString([], { hour12: false })}</span> · {line(ev)}
          </li>
        ))}
      </ol>
    )}
  </aside>
);
